import { DateInMilliSec, Locale } from "@common/constans";
import { IFlightPoint } from "@common/models";
import { Culture } from "@core/index";
import { store } from "@misc/Reducer";
import Config from "@service/Config";
import Translate from "@service/Translate";
interface IDateTimeFormatOptions {
    format?: string;
    locale?: string;
    utc?: boolean;
}

export const formatToDateTime = (value: number, options?: IDateTimeFormatOptions): string | undefined => {
    if (value && !isNaN(value)) {
        const dateTime = Culture.getDateTimeInstance(options?.locale);
        const dateTimeForamt = options?.format ? options.format : dateTime.locale.defaultDateTimeFormat;
        dateTime.setTime(value);
        return dateTime.format(dateTimeForamt, options?.utc);
    }
    return undefined;
}

export const getBeautyTime = (date: number, compareDate: number, format: string) => {
    const dateTime = Culture.getDateTimeInstance();
    dateTime.setTime(compareDate)
    return dateTime.format(format);
}

export const formatToDate = (value: number, options: IDateTimeFormatOptions = { utc: true }): string | undefined => {
    if (value && !isNaN(value)) {
        const date = Culture.getDateTimeInstance(options?.locale);
        const dateForamt = options?.format ? options.format : date.locale.defaultDateFormat;
        date.setTime(value);
        return date.format(dateForamt, options?.utc);
    }
    return undefined;
}

export const formatToMonthYear = (lang: string): string => {
    const IrLocale = Culture.getLocale(Locale.fa);
    if (lang === IrLocale?.lang)
        return "a M Y";
    else
        return "M a, Y";
}

export const formatToDayMonth = (lang: string): string => {
    const IrLocale = Culture.getLocale(Locale.fa);
    if (lang === IrLocale?.lang)
        return "l a M";
    else
        return "M a, Y";
}

export const setToDawn = (timeStamp: number, loacle: boolean = false): number => {
    const dateTime = Culture.getDateTimeInstance();
    dateTime.setTime(timeStamp);
    loacle ? dateTime.setHours(0, 0, 0, 0) : dateTime.setUTCHours(0, 0, 0, 0);
    return dateTime.getTime();
}

export function setToLocaleDawn(timeStamp: number | undefined): number | undefined {
    if (timeStamp) {
        const dateTime = Culture.getDateTimeInstance();
        dateTime.setTime(timeStamp);
        dateTime.setHours(0, 0, 0, 0);
        const timezoneOffset = dateTime.getTimezoneOffset();
        dateTime.setTime(dateTime.getTime() - (timezoneOffset * 60 * 1000));
        return dateTime.getTime();
    }
    return undefined;
}

export const setToEvenFall = (timeStamp: number, loacle: boolean = false): number => {
    const dateTime = Culture.getDateTimeInstance();
    dateTime.setTime(timeStamp);
    loacle ? dateTime.setHours(23, 59, 59, 0) : dateTime.setUTCHours(23, 59, 59, 0);
    return dateTime.getTime();
}

export const formatToBase64 = (file: File) => new Promise<string | ArrayBuffer | null>((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});

export const comma = () => {
    const IrLocale = Culture.getLocale(Locale.fa);
    const lang = Culture.getLocale()?.lang;
    if (lang === IrLocale?.lang)
        return "،";
    else
        return ",";
}

export const minToMinHour = (value: number) => {
    const { tr } = Translate;
    const IrLocale = Culture.getLocale(Locale.fa);
    const lang = Culture.getLocale()?.lang;
    const hour = Math.floor(value / 60);
    const minute = value % 60;
    if (lang === IrLocale?.lang)
        return (hour ? `${hour} ${tr("hour")} ` : '') + (minute ? `${minute} ${tr("min_abbreviation")}` : '');
    else
        return (hour ? `${hour}${tr("hour")} ` : '') + (minute ? `${minute}${tr("min_abbreviation")}` : '');
}

export const miliSecondToMinHour = (value: number) => {
    const { tr } = Translate;
    const IrLocale = Culture.getLocale(Locale.fa);
    const lang = Culture.getLocale()?.lang;
    const hour = Math.floor(value / DateInMilliSec.hourPerMilliSeconds);
    const hourDiff = value % DateInMilliSec.hourPerMilliSeconds
    const minute = Math.floor(hourDiff / DateInMilliSec.minutePerMilliSeconds);
    if (lang === IrLocale?.lang)
        return (hour ? `${hour} ${hour === 1 ? tr("hour").toLowerCase() : tr("hours")} ` : '') + (minute ? `${minute} ${minute === 1 ? tr("minute") : tr("min_abbreviation")}` : '');
    else
        return (hour ? `${hour} ${hour === 1 ? tr("hour").toLowerCase() : tr("hours")} ` : '') + (minute ? `${minute} ${minute === 1 ? tr("minute") : tr("min_abbreviation")}` : '');
}

export const miliSecondToDays = (value: number, justHours?: boolean) => {
    const { tr } = Translate;
    const IrLocale = Culture.getLocale(Locale.fa);
    const lang = Culture.getLocale()?.lang;
    const days = Math.floor(value / DateInMilliSec.dayPerMilliSeconds);
    const daysDiff = value % DateInMilliSec.dayPerMilliSeconds
    const hours = Math.floor(daysDiff / DateInMilliSec.hourPerMilliSeconds);
    if (lang === IrLocale?.lang)
        return (days ? `${days} ${hours === 1 ? tr("day").toLowerCase() : tr("days")} ` : '') + (!justHours && hours ? `${hours} ${hours === 1 ? tr("hour").toLowerCase() : tr("hours")} ` : '');
    else
        return (days ? `${days} ${hours === 1 ? tr("day").toLowerCase() : tr("days")} ` : '') + (!justHours && hours ? `${hours} ${hours === 1 ? tr("hour").toLowerCase() : tr("hours")} ` : '');
}

export function toPascalCase(str: string) {
    return str?.replace(/\w\S*/g, (txt: string) => {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}

export const getCountryName = (code: string) => {
    const country = store.getState().countriesData.find(s => s.code === code);
    return country?.name;
}

export const getAirport = (code: string = ""): IFlightPoint => {
    const airport = store.getState().airports.find(a => a.code === code) || {};
    return airport;
}

export const getAirportByCityName = (cityName: string = ""): IFlightPoint => {
    const airport = store.getState().airports.find(a => a.cityName === cityName) || {};
    return airport;
}

export const getAirportsByCityName = (cityName: string = ""): IFlightPoint[] => {
    const airport = store.getState().airports.filter(a => a.cityName === cityName) || {};
    return airport;
}

export const htmlSanitizer = (str: string): string => {
    return Config.getConfig().env === "Production" || Config.getConfig().env === "Staging" ? str.replace("content-preview", "content") : str
}

export async function translate(key: string) {
    key = encodeURI(key);
    const response = await fetch(`https://translate.googleapis.com/translate_a/single?client=gtx&sl=auto&tl=en&hl=fa-IR&q=${key}&dj=1&dt=t`);
    const data = await response.json();
    return data;
}
